// web-frontend/src/shared/hooks/usePageTracking.js
// 🔥 페이지 뷰 자동 추적 훅
// - React Router의 location 변경을 감지하여 analyticsService.trackPageView() 호출
// - MainLayout에서 한 번만 사용하면 모든 페이지 전환이 자동 추적됩니다.

import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import analyticsService from '../services/analyticsService';

/**
 * 페이지 뷰 자동 추적 훅
 *
 * @example
 * // MainLayout.jsx에서 사용
 * const MainLayout = ({ children }) => {
 *   usePageTracking();
 *   return <div>{children}</div>;
 * };
 */
export default function usePageTracking() {
  const location = useLocation();
  const prevPathRef = useRef(null);

  useEffect(() => {
    const currentPath = location.pathname;

    // 동일 경로 재진입은 무시 (쿼리스트링 변경 등)
    if (currentPath === prevPathRef.current) return;

    prevPathRef.current = currentPath;
    analyticsService.trackPageView(currentPath);

  }, [location.pathname]);
}